export const ORDER_TYPES = {
  booking: 'booking',
  voucher: 'voucher',
  giftcard: 'giftcard',
};

const orderStatuses = {
  onHoldPartner: {
    id: 'on_hold-partner',
    className: 'pending',
    label: app_main_wpml.onHoldPartnerLabel,
    description: app_main_wpml.onHoldPartnerDescription,
  },
  onHoldAlternative: {
    id: 'on_hold-alternative',
    className: 'pending',
    label: app_main_wpml.onHoldAlternativeLabel,
    description: app_main_wpml.onHoldAlternativeDescription,
  },
  onHoldRefused: {
    id: 'on_hold-refused',
    className: 'pending',
    label: app_main_wpml.onHoldRefusedLabel,
    description: app_main_wpml.onHoldRefusedDescription,
  },
  onHoldExpired: {
    id: 'on_hold-expired',
    className: 'pending',
    label: app_main_wpml.onHoldExpiredLabel,
    description: app_main_wpml.onHoldExpiredDescription,
  },
  confirmedBooking: {
    id: 'confirmed-booking',
    className: 'success',
    label: app_main_wpml.confirmedBookingLabel,
    description: app_main_wpml.confirmedBookingDescription,
  },
  confirmedPostponed: {
    id: 'confirmed-postponed',
    className: 'success',
    label: app_main_wpml.confirmedPostponedLabel,
    description: app_main_wpml.confirmedPostponedDescription,
  },
  confirmedSuspended: {
    id: 'confirmed-suspended',
    className: 'pending',
    label: app_main_wpml.confirmedSuspendedLabel,
    description: app_main_wpml.confirmedSuspendedDescription,
  },
  confirmedVoucher: {
    id: 'confirmed-voucher',
    className: 'success',
    label: app_main_wpml.confirmedVoucherLabel, // Voucher attivo
    description: app_main_wpml.confirmedVoucherDescription,
  },
  completedBooking: {
    id: 'completed-booking',
    className: 'success',
    label: app_main_wpml.completedBookingLabel,
    description: app_main_wpml.completedBookingDescription,
  },
  completedVoucher: {
    id: 'completed-voucher',
    className: 'success',
    label: app_main_wpml.completedVoucherLabel, // Voucher utilizzato
    description: app_main_wpml.completedVoucherDescription,
  },
  expiredVoucher: {
    id: 'expired-voucher',
    className: 'success', // alert
    label: app_main_wpml.expiredVoucherLabel, // Voucher scaduto
    description: app_main_wpml.expiredVoucherDescription,
  },
  refused: {
    id: 'refused',
    className: 'alert',
    label: app_main_wpml.refusedLabel,
    description: app_main_wpml.refusedDescription,
  },
  cancelled: {
    id: 'cancelled-customer',
    className: null,
    label: app_main_wpml.cancelledLabel,
    description: app_main_wpml.cancelledDescription,
  },
  refunded: {
    id: 'cancelled-partner',
    className: null,
    label: app_main_wpml.refundedLabel,
    description: app_main_wpml.refundedDescription,
  },
  withdrawn: {
    id: 'withdrawn',
    className: null,
    label: app_main_wpml.withdrawnLabel,
    description: app_main_wpml.withdrawnDescription,
  },
  completedGiftcard: {
    id: 'completed-giftcard',
    className: 'success',
    label: app_main_wpml.completedGiftcardLabel,
    description: app_main_wpml.completedGiftcardDescription,
  },
  redeemedGiftcard: {
    id: 'redeemed-giftcard',
    className: 'success',
    label: app_main_wpml.redeemedGiftcardLabel, // Gift Card utilizzata
    description: app_main_wpml.redeemedGiftcardDescription,
  },
  expiredGiftcard: {
    id: 'expired-giftcard',
    className: 'alert',
    label: app_main_wpml.expiredGiftcardLabel, // Gift Card scaduta
    description: app_main_wpml.expiredGiftcardDescription,
  },
};

export const ORDER_STATUSES = Object.freeze(
  (() => {
    const statuses = {};
    Object.keys(orderStatuses).forEach((k) => {
      statuses[k] = orderStatuses[k].id;
    });
    return statuses;
  })()
);

export const ORDER_STATUSES_LABELS = Object.freeze(
  (() => {
    const labels = {};
    Object.values(orderStatuses).forEach((status) => {
      labels[status.id] = status.label;
    });
    return labels;
  })()
);

export const ORDER_STATUSES_DESCRIPTIONS = Object.freeze(
  (() => {
    const descriptions = {};
    Object.values(orderStatuses).forEach((status) => {
      descriptions[status.id] = status.description;
    });
    return descriptions;
  })()
);

export const ORDER_STATUSES_CLASSNAMES = Object.freeze(
  (() => {
    const classNames = {};
    Object.values(orderStatuses).forEach((status) => {
      classNames[status.id] = status.className;
    });
    return classNames;
  })()
);

export const REVIEW_STATUS = {
  NOT_REVIEWABLE: 'not_reviewable',
  REVIEWABLE: 'reviewable',
  EDITABLE: 'editable',
  DRAFT: 'draft',
};

export const CUSTOMER_REQUEST_TYPE = {
  COMPLETED_BOOKING_TO_VOUCHER: 'completed_booking_to_voucher',
  COMPLETED_BOOKING_REFUND: 'completed_booking_refund',
  COMPLETED_BOOKING_NEW_DATE: 'completed_booking_new_date',
};

export const ORDER_ACTIONS = {
  VOUCHER_WITHDRAW: 'voucher_withdraw',
  VOUCHER_TO_GIFTCARD: 'voucher_to_giftcard',
  ONHOLD_TO_GIFTCARD: 'onhold_to_giftcard',
  ONHOLD_TO_VOUCHER: 'onhold_to_voucher',
  ONHOLD_NEW_DATE: 'onhold_new_date',
  ONHOLD_REFUND: 'onhold_refund',
  COMPLETED_BOOKING_REFUND: 'completed_booking_refund',
  COMPLETED_BOOKING_TO_VOUCHER: 'completed_booking_to_voucher',
  COMPLETED_BOOKING_NEW_DATE: 'completed_booking_new_date',
  GIFTCARD_DELETE: 'giftcard_delete',
  CONFIRMED_BOOKING_REFUND: 'confirmed_booking_refund',
  CONFIRMED_BOOKING_NEW_DATE: 'confirmed_booking_new_date',
  CONFIRMED_BOOKING_TO_VOUCHER: 'confirmed_booking_to_voucher',
  CONFIRMED_BOOKING_TO_GIFTCARD: 'confirmed_booking_to_giftcard',
  DOWNLOAD: 'download',
  RESEND_EMAIL: 'resend_email',
  REPORT_PROBLEM: 'report_problem',
};
